import React, { Component } from 'react';

import { StringUtils } from '../utils';
import { Header } from '../components';
import { Routes as routes } from '../navigation';
import '../css/UserProfile.css';

class UserProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderUserProfile = (user) => {
    if (!user) {
      return null
    }

    return <div className="standard-container">
      <Header title='User Profile' icon='fas fa-user-alt' button_title='Edit' button_action={ () => { this.props.userActions.openEditUser() }} />
      <div className="flex-container flex-container-row" style={{ padding: 10, alignItems: 'center', justifyContent: 'space-between' }}>
        <div className="flex-container flex-container-row" style={{ alignItems: 'center' }}>
        <div>
          { user.photo_url ? <img className="user-profile-profile-image" src={user.photo_url} />
          : <span className="fas fa-user-circle" style={{ fontSize: 50, color: '#e9e9e9' }}></span> }
        </div>
        <div style={{ marginLeft: 15 }}>
          <div style={{ fontSize: 13, color: '#575757' }}>{ StringUtils.displayName(user) }</div>
          <div style={{ fontSize: 12, color: 'grey' }}>{ user.email }</div>
        </div>
        </div>
        <div className="flex-container flex-container-column" style={{ paddingRight: 10, alignItems: 'center' }}>
          <div style={{ fontSize: 13, color: '#575757' }}>PROVIDER</div>
          <div style={{ fontSize: 10, color: 'grey' }}>ACCOUNT TYPE</div>
        </div>
      </div>
    </div>
  }

  render() {
    return this.renderUserProfile(this.props.user);
  }

}


export default UserProfile
